// DS: I110
// from GDrive
import React from 'react';
import IconWrap, { Props } from '../IconWrap';

const ArtStageArrowL: React.FC<Props> = props => (
  <IconWrap {...props}>
    <svg
      width="27"
      height="48"
      viewBox="0 0 27 48"
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
    >
      <path d="M3 21L24 0l3 3L6 24l21 21-3 3L0 24l3-3z" fillRule="evenodd" />
    </svg>
  </IconWrap>
);
ArtStageArrowL.displayName = 'ArtStageArrowL';

export default ArtStageArrowL;
